type PaymentResultModalLike = {
  message?: string;
} | null;

const normalizeErrorMessage = (value: string | null | undefined) => String(value || '').trim();

export const shouldShowInlineFormError = (
  formError: string,
  paymentResultModal: PaymentResultModalLike
) => {
  const normalizedFormError = normalizeErrorMessage(formError);
  if (!normalizedFormError) return false;

  const modalError = normalizeErrorMessage(paymentResultModal?.message);
  if (!modalError) return true;

  return normalizedFormError !== modalError;
};
